var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.startStream)?_c('LiveStream',{attrs:{"name":_vm.name,"email":_vm.email,"sirname":_vm.sirname,"allowedToSendEmail":_vm.allowedToSendEmail}}):_c('StartScreen',{on:{"formsubmitted":_vm.startScreenSubmitted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }